import { ServiceBase } from "../core";

export type ProductResponse = {
  data: {
    product: Product;
  };
};

export type Product = {
  base_name: string;
  id: string;
  descr?: string;
  name?: string;
  application_instructions: string;
  offline_application: boolean;
  bond_preview_url: string;
  is_external_product?: boolean;
  external_product?: ExternalProduct | null;
};

export type ExternalProductFieldDefinition = {
  name: string;
  field_type: string;
  label: string;
  tooltip: string;
};

export type ExternalProductPriceQuote = {
  bond_amount: number;
  term: string;
  premium_in_cents: number;
};

/**
 * @see ExternalBondRecordsService.submitOrder
 */
export type ExternalProduct = {
  integration: string;
  obligation_id: string;

  title: string;
  activity_name: string;
  agent_information: string;
  bond_form_preview_url: string | null;

  state: string;
  obligee_name: string;

  bond_amounts: number[];
  price_quotes: ExternalProductPriceQuote[];

  term_length: number;
  year_increments: number[];
  expiration_directive: string;
  expiration_day_of_year: string;
  can_renew: boolean;

  instant_issue: boolean;
  requires_wet_signature: boolean;
  requires_principal_legal_structure: boolean;

  form_specific_fields: ExternalProductFieldDefinition[];
};

class ProductsService extends ServiceBase {
  public static getProductById(id: string | null): Promise<ProductResponse> {
    return ServiceBase.callApi({
      method: "GET",
      url: `/products/${id}`,
    });
  }

  public static getStatesInfo(sc: string | null) {
    return ServiceBase.callApi({
      method: "GET",
      url: `/states/${sc}`,
    });
  }

  public static getPortalSiteInfo() {
    return ServiceBase.callApi({
      method: "GET",
      url: `/system/portal-site-info/current`,
    });
  }
}

export default ProductsService;
